import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { isLoginVisibleSelector, isRegisterVisibleSelector } from "../selectors";
import Component from "./component";

const mapStateToProps = (state: AppState): WithIsVisibleHOCProps => {
  const isLoginVisible = isLoginVisibleSelector(state);
  const isRegisterVisible = isRegisterVisibleSelector(state);

  return {
    isVisible: isLoginVisible || isRegisterVisible
  };
};

export default connectCustom(mapStateToProps)(Component);
